<template lang="pug">
  .job-search-csv-download(v-if="available")
    button.job-search-csv-download__trigger(type="button" @click="open" :disabled="disabled")
      span.job-search-csv-download__label CSV一括ダウンロード
      span.job-search-csv-download__limit 最大10,000件
</template>

<script>
import { snake } from 'change-case'
import { mapGetters } from 'vuex'

export default {
  props: ['totalCount'],
  computed: {
    ...mapGetters('user', ['demo', 'searchJobCsvDownloadEnabled']),
    ...mapGetters('uploadArchive', ['isUploading']),
    ...mapGetters('common', ['downloading']),
    available () {
      return !this.demo && this.searchJobCsvDownloadEnabled &&
        (parseInt(this.$route.query.page, 10) || 1) === 1 &&
        Number(this.totalCount) > 0
    },
    disabled () {
      return this.isUploading || this.downloading
    },
  },
  methods: {
    search () {
      const search = Object.keys(this.$route.query).reduce(
        (result, key) => Object.assign(result, { [snake(key)]: this.$route.query[key] }),
        {},
      )
      search.haken = this.$route.name === 'SearchHaken'
      return search
    },
    open () {
      if (this.disabled) return
      this.$store.commit('common/setSearchJobCsvModal', {
        totalCount: Number(this.totalCount),
        search: this.search(),
      })
      this.$store.commit('common/showModal')
    },
  },
}
</script>

<!--
  開発サーバーでは legacy の静的 style.css が配信されない場合があるため、
  この新規操作の見た目はコンポーネントと一緒に bundle する。
-->
<style>
.job-search-csv-download {
  /* 既存のヘッダー操作（高さ30px・上余白9px）と揃える。 */
  margin: 9px 8px 0 0;
}

.job-search-csv-download__trigger {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 30px;
  padding: 0 12px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  text-align: left;
  background: #395183;
  border: 1px solid #395183;
  border-radius: 4px;
  cursor: pointer;
}

.job-search-csv-download__trigger::before {
  margin-right: 6px;
  font-family: FontAwesome;
  font-size: 14px;
  font-weight: normal;
  content: '\f56d';
}

.job-search-csv-download__trigger:hover:not(:disabled) {
  background: #28416f;
  border-color: #28416f;
}

.job-search-csv-download__trigger:disabled {
  cursor: not-allowed;
  opacity: .65;
}

.job-search-csv-download__label,
.job-search-csv-download__limit {
  display: block;
}

.job-search-csv-download__limit {
  margin-left: 6px;
  padding-left: 6px;
  font-size: 11px;
  font-weight: normal;
  border-left: 1px solid rgba(255, 255, 255, .55);
}

@media screen and (max-width: 767px) {
  .job-search-csv-download {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/JobSearchCsvDownload.vue